/**
 * Owner: Masa Bayu
 * File: commerce-order-confirm.ts
 * Date:Time: 2026-09-15 22:46
 * Description: T3-E2 order confirmation after successful payment (≠ Library).
 */
import { assertNoForbiddenFoundationKey } from './authority';
import { paymentAllowsEntitlement } from './commerce-payment';
import { assertTimestamp, assertValidId } from './guards';
export const QXREAD_CONFIRMED_ORDER_STATES = ['confirmed'];
export function confirmOrderAfterSuccessfulPayment(order, attempt, options) {
    assertNoForbiddenFoundationKey(options ?? {}, 'QXRead order confirmation');
    if (order.state !== 'pending') {
        throw new Error('QXRead order confirmation requires a pending order');
    }
    if (attempt.orderId !== order.orderId) {
        throw new Error('QXRead payment attempt orderId mismatch');
    }
    if (!paymentAllowsEntitlement(attempt)) {
        throw new Error('QXRead order confirmation requires a succeeded payment attempt');
    }
    assertValidId(attempt.attemptId, 'QXRead payment attemptId');
    const confirmedAt = options?.confirmedAt ?? new Date().toISOString();
    assertTimestamp(confirmedAt, 'QXRead order confirmedAt');
    return Object.freeze({
        orderId: order.orderId,
        checkoutId: order.checkoutId,
        cartId: order.cartId,
        state: 'confirmed',
        lines: order.lines,
        totals: order.totals,
        createdAt: order.createdAt,
        confirmedAt,
        paymentAttemptId: attempt.attemptId,
        entitlementBatchId: null,
    });
}
/** Failed payment keeps the order pending for retry — never issues entitlement. */
export function markOrderAfterFailedPayment(order, attempt) {
    if (order.state !== 'pending') {
        throw new Error('QXRead failed-payment mark requires a pending order');
    }
    if (attempt.orderId !== order.orderId) {
        throw new Error('QXRead payment attempt orderId mismatch');
    }
    if (attempt.state !== 'failed') {
        throw new Error('QXRead failed-payment mark requires a failed payment attempt');
    }
    return Object.freeze({
        ...order,
        state: 'pending',
        paymentAttemptId: attempt.attemptId,
        entitlementId: null,
    });
}
/** Cancelled payment cancels the pending order — never issues entitlement. */
export function cancelOrderAfterCancelledPayment(order, attempt) {
    if (order.state !== 'pending') {
        throw new Error('QXRead cancel requires a pending order');
    }
    if (attempt.orderId !== order.orderId) {
        throw new Error('QXRead payment attempt orderId mismatch');
    }
    if (attempt.state !== 'cancelled') {
        throw new Error('QXRead cancel requires a cancelled payment attempt');
    }
    return Object.freeze({
        ...order,
        state: 'cancelled',
        paymentAttemptId: attempt.attemptId,
        entitlementId: null,
    });
}
//# sourceMappingURL=commerce-order-confirm.js.map